import React from 'react';
import { Certificate } from '../../api/productService';
import './CertificatesList.css';
import IconSVG from "../IconSVG";

interface CertificatesListProps {
  items: Certificate[];
  onItemClick?: (certificate: Certificate) => void;
}

const CertificatesList: React.FC<CertificatesListProps> = ({ items, onItemClick }) => {
  const handleItemClick = (certificate: Certificate) => {
    if (onItemClick) {
      onItemClick(certificate);
    }
  };

  return (
    <div className="certificates-list">
      {items.map((certificate, index) => {
        const isFirst = index === 0;
        const isLast = index === items.length - 1;
        const isMiddle = !isFirst && !isLast;

        return (
          <div
            key={certificate.id}
            className={`certificate-item ${isFirst ? 'first' : ''} ${isLast ? 'last' : ''} ${isMiddle ? 'middle' : ''}`}
            onClick={() => handleItemClick(certificate)}
          >
            <div className="certificate-icon">
              <div className="certificate-avatar">
                <IconSVG path={`/images/ui-svg/ai-icons/${certificate.courseId}.svg`} size={28}/>
                {/*{certificate.name.charAt(0).toUpperCase()}*/}
              </div>
            </div>
            <div className="certificate-content">
              <div className="certificate-name">{certificate.name}</div>
            </div>
            <div className="certificate-status">
              <IconSVG path={'/images/ui-svg/cert-completed-icon.svg'} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CertificatesList;
